import { render, staticRenderFns } from "./MedianAgeTile.vue?vue&type=template&id=0c744809"
import script from "./MedianAgeTile.vue?vue&type=script&lang=js"
export * from "./MedianAgeTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports